module.exports = __webpack_public_path__ + "img/iPhoneX.996fb072.png";